import React from "react";
import "./ProblemSection.css";

function ProblemSection() {
  return (
    <section className="container problem-section py-5">
      <div className="px-3 px-md-0">

        <div className="row g-4">

          {/* LEFT SIDE */}
          <div className="col-lg-7">

            <h2 className="section-title mb-2 mb-lg-3">
              The Problem We're Solving 
            </h2>

            <p>
              The traditional education-to-employment pipeline is broken.
            </p>

            <ul className="mb-3 problem-section-list">
              <li>Degrees signal pedigree.</li>
              <li>Resumes signal keywords.</li>
              <li>Job descriptions signal tasks.</li>
            </ul>

            <p className="mb-4">
              None of them reliably signal skills, capability, or performance.
            </p>


            {/* STAT CARDS */}
            <div className="row g-4 ">

              <div className="col-md-6">
                <div className="problem-stat-box  p-4 h-100">
                  <h3 className="problem-stats">78%</h3>
                  <p className="problem-stat-desc">
                    of students call their degree the most important financial
                    investment of their lives — yet employers still struggle
                    to assess real job readiness.
                  </p>
                </div>
              </div>

              <div className="col-md-6">
                <div className="problem-stat-box p-4  h-100">
                  <h3 className="problem-stats">50%</h3>
                  <p className="problem-stat-desc">
                    of jobs will require new skillsets by 2027 (World Economic
                    Forum). Institutions move in years. Skills evolve in months.
                  </p>
                </div>
              </div>

              <div className="col-12">
                <div className="problem-stat-box p-4">
                  <h3 className="problem-stats">50%</h3>
                  <p className="problem-stat-desc">
                    of education searches have shifted to non-traditional
                    pathways since 2020 (certifications, bootcamps,
                    micro-credentials). The market has already voted for skills.
                  </p>
                </div>
              </div>

            </div>

          </div>


          {/* RIGHT SIDE */}
          <div className="col-lg-5 d-flex text-white">

            <div className="adv-card w-100 p-4 p-lg-5">

              <h4 className="adv-title mb-4">
                When professionals pursue advancement:
              </h4>

              <div className="d-flex gap-3 mb-4">
                <span className="adv-num">01</span>
                <div>
                  <div className="adv-percent">41%</div>
                  <p className="mb-0 adv-details">want a new career path</p>
                </div>
              </div>

              <div className="d-flex gap-3 mb-4">
                <span className="adv-num">02</span>
                <div>
                  <div className="adv-percent">35%</div>
                  <p className="mb-0 adv-details">want to enter a new industry</p>
                </div>
              </div>

              <div className="d-flex gap-3 mb-4">
                <span className="adv-num">03</span>
                <div>
                  <div className="adv-percent">31%</div>
                  <p className="mb-0 adv-details">want a salary increase</p>
                </div>
              </div>

              <p className="adv-details mb-0">
                Education that doesn't convert into measurable career mobility
                isn't education. It's overhead.
              </p>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
}

export default ProblemSection;